import { Button, TableBody, TableCell, TableRow, Table } from '@mui/material'
import styled from 'styled-components'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { updateClubProviderMapping } from 'store/club/thunks'
import { selectCourse } from 'store/course/slice'
import { updateCourseProviderMapping } from 'store/course/thunks'

enum STATUS {
  MAPPED = 'Mapped',
  ACTIVATED = 'Activated',
}

interface TableProps {
  providerCourses: ProviderSearchCourses[]
  course: Course
  provider: string
  clubMappingStatus: string
  providerClubId: string
  club: Club
}

export default function ProviderSearchCourses({
  course,
  providerCourses,
  provider,
  clubMappingStatus,
  providerClubId,
  club,
}: TableProps) {
  const intl = useIntl()
  const dispatch = useDispatch()
  const MAPPED = 'Mapped'
  const { updateCourseProviderMappingStatus } = useSelector(selectCourse)
  const [loadMapping, setLoadMapping] = useState(null)

  const columnsCourse: TableColumn[] = [
    {
      id: 'CourseId',
      label: intl.formatMessage({ id: 'strings.courseId' }),
    },
    {
      id: 'providerCourseId',
      label: intl.formatMessage({ id: 'strings.providerCourseId' }),
    },
    {
      id: 'CourseName',
      label: intl.formatMessage({ id: 'strings.courseName' }),
    },
    {
      id: 'providerCourseName',
      label: intl.formatMessage({ id: 'strings.providerCourseName' }),
    },
    {
      id: 'courseActiveStatus',
      label: intl.formatMessage({ id: 'strings.ggbStatus' }),
    },
    {
      id: 'courseMappingStatus',
      label: intl.formatMessage({ id: 'strings.mappingStatus' }),
    },
    {
      id: 'providerStatus',
      label: intl.formatMessage({ id: 'strings.providerStatus' }),
    },
  ]

  useEffect(() => {
    if (updateCourseProviderMappingStatus !== 'loading') {
      setLoadMapping(null)
    }
  }, [updateCourseProviderMappingStatus])

  const isMappingAllowed = (mapped: string, providerStatus: string) => {
    return providerStatus.includes('Deactivated') || mapped.includes('Provider missing data')
  }

  const handleClick = ({ providerCourseId }) => {
    if (!course.providerCourseMap?.id || !course.isOfficial) {
      return
    }
    setLoadMapping(providerCourseId)
    if (clubMappingStatus == MAPPED) {
      dispatch(
        updateCourseProviderMapping({
          courseId: course.id,
          newProvider: provider,
          newProviderId: providerCourseId,
          courseProviderMapId: course.providerCourseMap?.id,
        }),
      )
    } else {
      if (!club.providerClubMap) {
        return
      }
      dispatch(
        updateClubProviderMapping({
          courseId: course.id,
          newProvider: provider,
          newProviderCourseId: providerCourseId,
          clubId: club.id,
          newProviderClubId: providerClubId,
          clubProviderMapId: club.providerClubMap?.providerClubId,
          courseProviderMapId: course.providerCourseMap.id,
        }),
      )
    }
  }

  return (
    <React.Fragment>
      <Table>
        <TableBody>
          <StyledTableHeadRow>
            <TableCell sx={{ backgroundColor: '#11A85D' }}></TableCell>
            {columnsCourse.map((info, index) => {
              return (
                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#11A85D' }} key={index}>
                  {info.label}
                </TableCell>
              )
            })}
          </StyledTableHeadRow>

          {providerCourses.map((course) => {
            return (
              <TableRow key={course.providerCourseId}>
                <TableCell sx={{ color: '#11A85D' }}>
                  <Button
                    disabled={isMappingAllowed(course.mapped, course.providerActivated)}
                    onClick={() => handleClick({ providerCourseId: course.providerCourseId })}
                  >
                    {loadMapping && loadMapping === course.providerCourseId ? 'Mapping...' : 'Map'}
                  </Button>
                </TableCell>
                <TableCell>{course.id}</TableCell>
                <TableCell>{course.providerCourseId}</TableCell>
                <TableCell>{course.name}</TableCell>
                <TableCell>{course.providerCourseName}</TableCell>
                <TableCell
                  sx={{
                    color: course.activated === STATUS.ACTIVATED ? '#11A85D' : 'red',
                  }}
                >
                  {course.activated}
                </TableCell>
                <TableCell
                  sx={{
                    color: course.mapped === STATUS.MAPPED ? '#11A85D' : 'red',
                  }}
                >
                  {course.mapped}
                </TableCell>
                <TableCell
                  sx={{
                    color: course.providerActivated === STATUS.ACTIVATED ? '#11A85D' : 'red',
                  }}
                >
                  {course.providerActivated}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </React.Fragment>
  )
}

const StyledTableHeadRow = styled(TableRow)`
  background-color: ${(props) => props.theme.palette.primary.dark};
  height: 40px;

  & td,
  span,
  span.MuiTableSortLabel-active {
    color: ${(props) => props.theme.customPalette.light};
    font-size: 13px;
    line-height: 15px;
    text-transform: uppercase;
  }
  & span:hover {
    color: ${(props) => props.theme.customPalette.light};
    opacity: 0.8;
  }
  & svg {
    color: #fff !important;
  }
`
